import { ActionContext } from 'vuex';
//import { RootState as DesktopRootState } from '../../../../Apps/Frontend.Desktop/js/src/store';
import { RootState as MobileRootState } from '../../../../Apps/Frontend.Mobile/js/src/store';
import { FETCH_USER_COUPONS } from 'core/store/action-types';
import { SET_USER_COUPONS } from 'core/store/mutation-types';
import * as api from 'core/api';

export interface UserState {
    coupons?: api.CouponListModel[];
}

const state: UserState = {
    coupons: undefined
};

const getters = {};

const actions = {
    [FETCH_USER_COUPONS](context: ActionContext<UserState, /*DesktopRootState |*/MobileRootState>) {
        return new api.CouponService().listAvailable().then(
            (result: api.CouponListModel[]) => {
                if (result && result.length > 0) {
                    context.commit(SET_USER_COUPONS, result);

                    return Promise.resolve(result);
                } else {
                    context.commit(SET_USER_COUPONS, []);

                    return Promise.resolve([]);
                }
            },
            (error) => {
                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }

                return Promise.reject(error);
            }
        );
    }
};

const mutations = {
    [SET_USER_COUPONS](state: UserState, payload: api.CouponListModel[]) {
        state.coupons = payload;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
